import React, { FunctionComponent } from 'react'
import { connect } from 'react-redux'

import { AnyAction, Dispatch } from 'redux'

import { Link } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/link/Link'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import * as ModalActions from '../../../features/page-components/modals/generic/modal-actions'
import VideoModal from '../modals/videoModal/VideoModal'

type VideoLinkProps = {
  linkText: string
  videoUrl: string
  description: string
  dispatch: Dispatch<AnyAction>
}

const VideoLink: FunctionComponent<VideoLinkProps> = ({
  linkText = 'this video',
  videoUrl = 'https://player.vimeo.com/video/196029128',
  description = 'What Is Therapy?',
  dispatch,
}) => {
  return (
    <Link
      testID={tID('VideoLink')}
      onPress={() => {
        dispatch(ModalActions.setModalContent(<VideoModal url={videoUrl} description={description} />))
        dispatch(
          ModalActions.setModalProps({
            showCloseButton: true,
          }),
        )
      }}
      text={linkText}
      underline
    />
  )
}

export default connect()(VideoLink)
